export default {
  solicitantes: 'Solicitantes',
  entidades: 'Entidades',
  cuenta: 'Cuentas',
  configuracion: 'Configuraciones',
  usuarios: 'Usuarios',
  tramites: 'Trámites',
  modulos: 'Módulos y permisos',
  roles: 'Roles',
  parametros: 'Preferencias',
  documentos: 'Documentos',
  logs: 'Logs del sistema',
  config: 'Configuraciones',
  pagos: 'Pagos',
  tramitesDoc: 'Solicitudes',
  reportes: 'Reportes'
};



// WEBPACK FOOTER //
// ./src/common/lang/es/menu.js